import * as React from "react";
const SvgVerifiedBadgeOutline = props => /*#__PURE__*/React.createElement("svg", {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4Zm7 10c0 4.52-2.98 8.69-7 9.93-4.02-1.24-7-5.41-7-9.93V6.3l7-3.11 7 3.11V11Zm-11.59.59L6 13l4 4 8-8-1.41-1.42L10 14.17l-2.59-2.58Z",
  fill: "currentColor"
}));
export default SvgVerifiedBadgeOutline;